import { render } from "./tickets-table-test.vue?vue&type=template&id=e64ca25e&scoped=true"
import script from "./tickets-table-test.vue?vue&type=script&lang=js"
export * from "./tickets-table-test.vue?vue&type=script&lang=js"

import "./tickets-table-test.vue?vue&type=style&index=0&id=e64ca25e&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e64ca25e"]])

export default __exports__